import React from 'react';
import PropTypes from 'prop-types';
import { Container } from 'react-bootstrap';
import { InfoMessage, LoadingStatusWrapper, PopOutChart } from 'sharedComponents';
import { apiCallStatus } from 'helpers/constants';
import useChartConfig, { chartPlugins } from './useChartConfig';
import { scatterContainerId } from './constants';
import { EmptyComparisonMessage } from '../EmptyComparisonMessage';

import '../style.scss';

const ScatterPlotComponent = ({
    asset,
    chartData,
    removeKPIData,
    chartLoadingStatus,
    chartErrorData,
    isZoomed,
    setIsZoomed,
    isComparisonView,
    offGraphSignalsCount
}) => {
    const chartOptions = useChartConfig(chartData, removeKPIData, asset);

    const renderNoKpiContent = () => {
        if (chartErrorData?.loadingStatus === apiCallStatus.ERROR) {
            return <InfoMessage
                title='ABB.Powertrain.Frontend.errorBoundaryMessageTitle500'
                text='ABB.Powertrain.Frontend.errorBoundaryMessageDesc500' />;
        }
        if (isComparisonView) {
            return <EmptyComparisonMessage offGraphSignalsCount={offGraphSignalsCount} />;
        }
        return <InfoMessage
            title='ABB.Powertrain.Frontend.chartNoKPIsSelected'
            text='ABB.Powertrain.Frontend.chartNoKPIsSelectedUserGuide' />;
    };

    return (
        <Container fluid className='cross-asset-chart-container'>
            <LoadingStatusWrapper
                useCustomAnchor
                transparent
                loadingStatus={chartLoadingStatus}>
                <PopOutChart
                    hasKpi={!!chartData?.length}
                    hasData={!!chartData?.length}
                    renderNoKpi={renderNoKpiContent}
                    renderNoData={() => <InfoMessage
                        title='ABB.Powertrain.Frontend.noDataLabelAvailable'
                        text='ABB.Powertrain.Frontend.adjustDateRangeOrChartType' />}
                    loadingStatus={chartLoadingStatus}
                    options={chartOptions}
                    modules={chartPlugins}
                    container={scatterContainerId}
                    isZoomed={isZoomed}
                    setIsZoomed={setIsZoomed}
                    hideDownloadButton={true}
                    isNotPreserveSignals={true}
                />
            </LoadingStatusWrapper>
        </Container>
    );
};

ScatterPlotComponent.propTypes = {
    asset: PropTypes.object,
    chartData: PropTypes.shape({
        length: PropTypes.number,
    }),
    removeKPIData: PropTypes.func,
    chartLoadingStatus: PropTypes.string,
    chartErrorData: PropTypes.object,
    isZoomed: PropTypes.bool,
    setIsZoomed: PropTypes.func,
    isComparisonView: PropTypes.bool,
    offGraphSignalsCount: PropTypes.number
};

export default ScatterPlotComponent;


